<template>
  <div class="blue-tip-logo"></div>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
.blue-tip-logo{
  width: 4px;
  height: 12px;
  background: #3D8EFF;
  border-radius: 1px;
}
</style>